/*
 * @Author: pengyong
 * @Date: 2020-11-11 22:18:05
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-15 17:05:41
 * @Description: 接口定义文件
 * @FilePath: /exhibit/src/api/index.js
 *
 * @example:
 * import api from '@/api
 * api.doLogin()
 */
import * as user from "./user";
import * as login from "./login";
import * as conference from "./conference";
import * as consulting from "./consulting";
import * as exhibition from "./exhibition";
import * as common from "./common";

export default {
    ...user,
    ...login,
    ...conference,
    ...consulting,
    ...exhibition,
    ...common
};



// WEBPACK FOOTER //
// ./src/api/index.js